// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 311) return "static/chunks/311-15a8a95ca0c3a58a.js";
	if (chunkId === 8) return "static/chunks/8-2d5103f7c14e24f1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"40f41063159daff9","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"841c0466e71505df","367":"f68cf0d3cd9d9d14","639":"cf9d73bb0d566e4a","748":"feee141e64dec05e"}[chunkId] + ".js";
};